<template>
  <div>
    <div class="content">
      <div class="banner">
        <div class="fixedContent">
          <div class="clickBtn left">
            <div>下载糖糖圈app了解更多</div>
            <div class="showCode"><img style="margin-top:10px" src="../../site/updataErcode.png"></div>
          </div>
          <!-- <div class="square left">
            <div class="squareTxt">下载糖糖圈APP了解更多</div>
            <div>
              <img src="../../site/updataErcode.png">
            </div>
          </div> -->
        </div>
      </div>


      <div class="titleIntro">
        <p class="titleTxt">开通VIP尊享<span style="color:#FFA71D">15</span>大权益</p>
        <p class="titleEnglish">Open VIP To Enjoy 15 Major Rights</p>
      </div>
      <div class="vipContent"> 
        <div class="vipList left">
          <div>
            <img src="../../site/vip1.png">
          </div>
          <p class="vipTitle">1对1血糖管理</p>
          <p class="vipTxt">糖尿病多学科医疗，一对一共同照护</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip2.png">
          </div>
          <p class="vipTitle">糖豆充值返点</p>
          <p class="vipTxt">糖豆1:1等值人民币，充值越多赠送越多</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip3.png">
          </div>
          <p class="vipTitle">会员商品折扣</p>
          <p class="vipTxt">会员尊享商品折扣，更低价格购买商品</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip4.png">
          </div>
          <p class="vipTitle">购泵订制优惠</p>
          <p class="vipTxt">订制购泵优惠方案，糖糖圈买泵最实惠</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip5.png">
          </div>
          <p class="vipTitle">付费课程折扣</p>
          <p class="vipTxt">资深调糖专家制作，高效助力自我管理</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip6.png">
          </div>
          <p class="vipTitle">心愿商品清单</p>
          <p class="vipTxt">提交心愿商品清单，糖糖圈为您采购</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip7.png">
          </div>
          <p class="vipTitle">共享糖化漂流</p>
          <p class="vipTxt">在家快速测糖化，省时省心更省钱</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip8.png">
          </div>
          <p class="vipTitle">动态血糖云</p>
          <p class="vipTxt">搭建血糖分享网址，实现远程查看血糖</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip9.png">
          </div>
          <p class="vipTitle">讲堂我做主</p>
          <p class="vipTxt">瞄准糖友痛点难点，开启会员主题讲堂</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip10.png">
          </div>
          <p class="vipTitle">商品全国包邮</p>
          <p class="vipTxt">商城商品全国包邮，省心还不话冤枉钱</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip11.png">
          </div>
          <p class="vipTitle">线下诊所照护</p>
          <p class="vipTxt">提前预约免费就诊，免费享多项检查</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip12.png">
          </div>
          <p class="vipTitle">每月特价商品</p>
          <p class="vipTxt">商城每月特价商品，会员尊享超低优惠</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip13.png">
          </div>
          <p class="vipTitle">新品优先试用</p>
          <p class="vipTxt">全球海量控糖新品，会员优先选购试用</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip14.png">
          </div>
          <p class="vipTitle">会员专属头像</p>
          <p class="vipTxt">专属会员身份标示，随时随地</p>
        </div>
        <div class="vipList left">
          <div>
            <img src="../../site/vip15.png">
          </div>
          <p class="vipTitle">专属客服1对1</p>
          <p class="vipTxt">会员分配专属客服，贴心一对一解答</p>
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="titleIntro">
        <p class="titleTxt">会员权益对比</p>
        <p class="titleEnglish">Member rights comparison</p>
      </div>
      <div class="vipInfo">
        <div class="vipInfoDesc left">
          <div class="vipInfoTitle">
            <img style="margin-top:15px" src="../../site/vs.png">
            <br>
            特权对比
          </div>
          <div class="vipInfoTxt"  style="margin-top:20px;">1对1血糖管理</div>
          <div class="vipInfoTxt">糖豆充值返点</div>
          <div class="vipInfoTxt">会员商品折扣</div>
          <div class="vipInfoTxt">购泵订制优惠</div>
          <div class="vipInfoTxt">付费课程折扣</div>
          <div class="vipInfoTxt">心愿商品清单</div>
          <div class="vipInfoTxt">共享糖化漂流</div>
          <div class="vipInfoTxt">动态血糖云</div>
          <div class="vipInfoTxt">讲堂我做主</div>
          <div class="vipInfoTxt">商品全国包邮</div>
          <div class="vipInfoTxt">线下诊所照护</div>
          <div class="vipInfoTxt">每月特价商品</div>
          <div class="vipInfoTxt">新品优先试用</div>
          <div class="vipInfoTxt">会员专属头像</div>
          <div class="vipInfoTxt">会员专属客服</div>    
        </div>
        <div class="vipInfoDesc left" style="margin-left:80px; width:267px;background-color:#fff;border:1px solid #D8D8D8">
          <div class="vipInfoTitle" style="background-color:#DFE8FF">
            <div style="position:absolute;right:0;bottom:15px">
              <img style="width:70px" src="../../site/huangguan1.png">
            </div>
            <div style="line-height:106px">
              续费制 VIP (1年)
            </div>
          </div>
          <div class="vipInfoTxt" style="margin-top:20px;">密集干预<span style="color:#FF622B">7</span>天-季度回访<span style="color:#FF622B">4</span>次</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt">胰岛素泵定制优惠</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">5</span>折优惠</div>
          <div class="vipInfoTxt">心愿商品定制</div>
          <div class="vipInfoTxt">一年<span style="color:#FF622B">1</span>次</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">1</span>年内有效</div>
          <div class="vipInfoTxt">一对一解答</div>    
        </div>
        <div class="vipInfoDesc left" style="margin-left:80px; width:267px;background-color:#fff;border:1px solid #D8D8D8">
          <div class="vipInfoTitle" style="background-color:#CBFFF3">
            <div style="position:absolute;right:0;bottom:15px">
              <img style="width:70px" src="../../site/huangguan2.png">
            </div>
            <div style="line-height:106px">
              续费制 VIP (3年)
            </div>
          </div>
          <div class="vipInfoTxt" style="margin-top:20px;">密集干预<span style="color:#FF622B">14</span>天-季度回访<span style="color:#FF622B">12</span>次</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt">胰岛素泵定制优惠</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">4</span>折优惠</div>
          <div class="vipInfoTxt">心愿商品定制</div>
          <div class="vipInfoTxt">一年<span style="color:#FF622B">2</span>次</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt">讲堂定制特权.第二次优先等级</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>年内有效</div>
          <div class="vipInfoTxt">一对一解答</div>    
        </div>
        <div class="vipInfoDesc left" style="margin-left:80px; width:267px;background-color:#FFFAFA;border:1px solid #FF9B8A">
          <div class="vipInfoTitle" style="background-color:#FFD9D6">

            <div style="position:absolute;left:0;top:0">
              <img style="width:70px" src="../../site/tuijian.png">
            </div>
            <div style="position:absolute;right:0;bottom:15px">
              <img style="width:70px" src="../../site/huangguan3.png">
            </div>
            <div style="line-height:106px">
              终身制VIP
            </div>
          </div>
          <div class="vipInfoTxt" style="margin-top:20px;">密集干预<span style="color:#FF622B">30</span>天-季度回访终身</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">终身</span>有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">终身</span>有效</div>
          <div class="vipInfoTxt">胰岛素泵定制优惠</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">3</span>折优惠</div>
          <div class="vipInfoTxt">心愿商品定制</div>
          <div class="vipInfoTxt">一年<span style="color:#FF622B">4</span>次</div>
          <div class="vipInfoTxt">免费搭建NS实现接收血糖信息</div>
          <div class="vipInfoTxt">讲堂定制特权.第一次优先等级</div>
          <div class="vipInfoTxt">终身免费挂号.每年一次.15项诊所服务权益</div>
          <div class="vipInfoTxt">/</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">终身</span>有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">终身</span>有效</div>
          <div class="vipInfoTxt"><span style="color:#FF622B">终身</span>有效</div>
          <div class="vipInfoTxt">一对一解答</div>    
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="titleIntro">
        <p class="titleTxt">常见问题</p>
        <p class="titleEnglish">common problem</p>
      </div>
      <div style="padding-bottom:100px; margin:auto; margin-top:30px; width:1100px;">
        <div class="problem left">
          <p class="problemTitle">1、开通糖糖圈VIP之后可以退款吗？</p>
          <p class="problemTxt">VIP为权益商品，包含服务，购买成功后立即生效，暂不接受退款，敬请谅解！</p>

          <p class="problemTitle">3、糖糖圈VIP价格会变化吗？</p>
          <p class="problemTxt">糖糖圈VIP上线初期，会有赠送活动。随着商城商品价格折扣加大、服务升级 等，VIP价格会浮动，赠送也会减少，已开通的VIP权益不受影响。越早开通， 越实惠，越早享受实惠。</p>

          <p class="problemTitle">5、糖糖圈VIP和商城会员有什么区别？</p>
          <p class="problemTxt">商城会员共有5个会员等级，通过在糖糖圈商城购物获取成长值升级（现金和 成长值的换取比例为1:1），仅在商城内购买商品可享受对应等级折扣，不涉 及商城商品外的内容。糖糖圈会员与商城会员不冲突、不共享。糖糖圈会员 通过付费购买开通会员，可享受多学科糖尿病医疗团队长期照护服务、商城 超低折扣优惠、APP专属权益等多项权益。</p>
        </div>
        <div class="problem right">
          <p class="problemTitle">2、什么糖豆，如何获得糖豆，在哪里可以使用糖豆？</p>
          <p class="problemTxt">开通VIP后，会拥有糖豆账户，糖豆兑人民币为1:1，糖豆仅用于消费，不可 提现或转赠；开通VIP时会赠送糖豆，可通过糖豆充值活动充值并获得赠送 糖豆，同时也可以通过积分按100:1兑换糖豆；可在糖糖圈app内所有消费 场景中使用糖豆抵扣，没有使用上限。</p>

          <p class="problemTitle">4、已经购买了续费制VIP，可以升级成为终身制VIP吗？</p>
          <p class="problemTxt">在VIP有效期内，可以通过补差价升级为终身制VIP。升级后，除去原有享受 VIP权益部分，补足升级后权益。</p>

          <p class="problemTitle">6、VIP到期后，权益会立马失效吗？</p>
          <p class="problemTxt">VIP到期后，已在服务中的权益继续有效，直到服务结束。未领取的权益会自 动失效，糖豆账户中的糖豆可继续消费，直到使用完后自动关闭。</p>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>



  </div>
</template>

<script>
export default {
  name: "userInfo",
  
  components: {
   
  },
  data() {
    return {
     
    };
  },
  methods: {
   
  },
  mounted() {
    
  }
};

</script>
<style scoped>
span{display: inline-block;}
.left{float: left;}
.right{float: right;}
.content{padding-top:90px}
.banner{position: relative; width:auto;height:554px;background:transparent url(../../site/userBanner.png) no-repeat center;background-size: cover;}
.fixedContent{position: absolute; bottom: 10px; left: 18%; width: 400px;height: 200px;}


.clickBtn{cursor: pointer; width:170px;height: 35px;color: #fff;font-size: 12px; line-height: 35px;text-align: center;background-color: #FC811B;border-radius: 20px;}
.showCode{display: none; background-color: #fff;border-radius: 0 0 15px 15px;}
.clickBtn:hover{border-radius: 20px 20px 0px 0px;}
.clickBtn:hover .showCode{display: block;}

.square{display: none; width: 170px;height: 170px;text-align: center; background-color: #fff;border-radius: 15px;overflow: hidden;}
.squareTxt{width: 170px;height:40px; color: #fff; text-align: center; line-height: 40px; font-size: 12px; background-color: #FC811B;}
.titleTxt{margin-top:120px;letter-spacing: 10px;text-align: center;font-size: 32px;color: #4F4F4F;}
.titleEnglish{margin-top:10px; font-size: 16px;color: #999999;text-align: center;}


.vipContent{margin:auto;width: 1200px;text-align: center;}
.vipList{width: 240px;margin-top: 70px;height: 140px;}
.vipTitle{margin-top:15px; font-size:16px;color: #4F4F4F;}
.vipTxt{display: none; margin-top:15px; font-size:12px;color: #999999;}

.vipInfo{margin: auto; margin-top: 80px; width: 1200px;}
.vipInfoDesc{width:150px;text-align: center;padding-bottom: 30px;}
.vipInfoTitle{position: relative; font-size: 18px; font-weight: bold; color: #4F4F4F;height: 106px;}
.vipInfoTxt{font-size: 14px;color: #4F4F4F;line-height: 30px;}

.problem{width: 500px;}
.problemTitle{margin-top: 40px; font-size:18px;color:#4F4F4F;}
.problemTxt{margin-top: 15px;font-size:14px; line-height: 25px; color:#999;}

.vipList:hover{animation:mymove .5s 1;}
.vipList:hover .vipTxt{display: block;}
@keyframes mymove
{
  from {transform:rotate(0deg)}
  to {transform:rotate(360deg)}
}
</style>



// WEBPACK FOOTER //
// userInfo.vue?6934da9e